// Configuration de l'API selon l'environnement

const config = {
  development: {
    apiUrl: 'https://api.dev-keslakay.com/api/v2/',
    apiDirectUrl: 'https://api.dev-keslakay.com/api/v2/',
    useProxy: false,
    debug: true,
    logLevel: 'debug'
  },
  production: {
    apiUrl: 'https://api.keslakay.com/api/v2/',
    apiDirectUrl: 'https://api.keslakay.com/api/v2/',
    useProxy: false,
    debug: false,
    logLevel: 'error'
  }
}

// Détection automatique de l'environnement
const environment = process.env.NODE_ENV || 'development'
const currentConfig = config[environment]

// Fonction pour obtenir la configuration
export const getApiConfig = () => {
  console.log(`🔧 Configuration ${environment.toUpperCase()}:`, {
    apiUrl: currentConfig.apiUrl,
    useProxy: currentConfig.useProxy,
    debug: currentConfig.debug
  })
  return currentConfig
}

// Export de la configuration actuelle
export default currentConfig
